import { darken, lighten } from '@mui/material/styles';

const palette = {
  mode: 'light',
  primary: {
    main: '#124131',
    contrastText: '#FFF',
  },
  secondary: {
    main: '#238061',
    contrastText: '#FFF',
  },
  ai: {
    main: '#0077B6',
    gradient: 'linear-gradient(to right, #0077B6, #4A50A8)',
    contrastText: '#FFF',
  },
  red: {
    main: '#7C2521',
    contrastText: '#FFF',
  },
  blue: {
    main: '#1F487E',
    contrastText: '#FFF',
  },
  yellow: {
    main: '#DFA639',
    contrastText: '#FFF',
  },
  orange: {
    main: '#D1603C',
    contrastText: '#FFF',
  },
  neutral: {
    main: '#D1DCDA',
    dark: darken('#D1DCDA', 0.1),
    light: lighten('#D1DCDA', 0.1),
    contrastText: '#333333',
  },
  emphasisText: {
    main: '#0B2920',
    contrastText: '#FFF',
  },
  greenGray: {
    main: '#12413114',
    contrastText: '#124131',
  },
  text: {
    primary: '#333333',
    secondary: '#5A5A5A',
  },
  background: {
    default: '#F7F9FC',
    paper: '#FFF',
    grey: '#FAFAFA',
    expand: '#edeff2',
  },
} as const;

export default palette;

type Color = {
  main: string;
  contrastText: string;
}

declare module '@mui/material/styles' {
  interface Palette {
    red: Color;
    blue: Color;
    yellow: Color;
    orange: Color;
    greenGray: Color;
    ai: {
      main: string;
      gradient: string;
    };
    neutral: {
      main: string;
      dark: string;
      light: string;
      contrastText: string;
    };
    emphasisText: Color;
  }
  interface PaletteOptions {
    red: Color;
    blue: Color;
    yellow: Color;
    orange: Color;
    greenGray: Color;
  }

  interface PaletteColor {
    red: Color;
    blue: Color;
    yellow: Color;
    orange: Color;
    greenGray: Color;
  }
  interface TypeBackground {
    default: string;
    paper: string;
    grey: string;
    expand: string;
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    ai: true;
    red: true;
    blue: true;
    yellow: true;
    orange: true;
    greenGray: true;
    background: true;
    'info.dark': true;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    'ai.gradient': true;
    red: true;
    blue: true;
    yellow: true;
    orange: true;
    greenGray: true;
    background: true;
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    red: true;
    blue: true;
    yellow: true;
    orange: true;
    ai: true;
    neutral: true;
  }
}
